import React from "react";
import { NavLink } from "react-router-dom";
import {
  LayoutGrid, AlertTriangle, ClipboardCheck, TriangleAlert, TrendingUp,
  FilePlus2, ShieldCheck, GraduationCap, IdCard, CalendarCheck, FileEdit,
  FolderArchive, LogOut, ShieldHalf, X, UserCog,
} from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const ROLE_LABEL = { admin: "Admin", editor: "Editor", viewer: "Viewer" };

const MENU = [
  { to: "/dashboard", label: "Dashboard HSE", icon: LayoutGrid },
  { to: "/finding-safety", label: "Finding Safety", icon: AlertTriangle },
  { to: "/finding-5s", label: "Finding 5S", icon: ClipboardCheck },
  { to: "/incident", label: "Incident", icon: TriangleAlert },
  { to: "/lagging-leading", label: "Lagging & Leading Indicator", icon: TrendingUp },
  { to: "/input-finding", label: "Input Finding", icon: FilePlus2 },
  { to: "/lif-ccv", label: "LIF & CCV", icon: ShieldHalf },
  { to: "/monitoring-training", label: "Monitoring Training", icon: GraduationCap },
  { to: "/monitoring-simper", label: "Monitoring Simper", icon: IdCard },
  { to: "/dashboard-absensi", label: "Dashboard Absensi", icon: CalendarCheck, noViewer: true },
  { to: "/input-absensi", label: "Input Absensi", icon: FileEdit, noViewer: true },
  { to: "/dokumen", label: "Dokumen Administratif", icon: FolderArchive },
  { to: "/kelola-akun", label: "Kelola Akun", icon: UserCog, adminOnly: true },
];

export default function Sidebar({ mobileOpen = false, onClose = () => {} }) {
  const { user, isAdmin, isViewer, role, logout } = useAuth();
  const items = MENU.filter((m) => {
    if (m.adminOnly && !isAdmin) return false;
    if (m.noViewer && isViewer) return false;
    return true;
  });

  return (
    <aside className={`no-print w-64 shrink-0 bg-[#0b1220] text-slate-300 flex flex-col h-screen fixed lg:sticky top-0 z-50 transition-transform duration-300 ${mobileOpen ? "translate-x-0" : "-translate-x-full"} lg:translate-x-0`}>
      <div className="flex items-center gap-3 px-5 py-5 border-b border-white/5">
        <div className="w-10 h-10 rounded-lg bg-white flex items-center justify-center">
          <ShieldCheck className="w-6 h-6 text-[#0b1220]" />
        </div>
        <div className="flex-1">
          <p className="text-white font-bold leading-tight">HSE Report</p>
          <p className="text-xs text-slate-400">PT. Ithikhara</p>
        </div>
        <button onClick={onClose} className="lg:hidden text-slate-400 p-1" data-testid="sidebar-close"><X className="w-5 h-5" /></button>
      </div>

      <nav className="flex-1 overflow-y-auto py-3 px-3 space-y-1">
        {items.map((m) => (
          <NavLink
            key={m.to}
            to={m.to}
            onClick={onClose}
            data-testid={`nav-${m.to.slice(1)}`}
            className={({ isActive }) =>
              `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                isActive ? "bg-amber-400 text-[#0b1220]" : "hover:bg-white/5 text-slate-300"
              }`
            }
          >
            <m.icon className="w-[18px] h-[18px]" />
            <span>{m.label}</span>
          </NavLink>
        ))}
      </nav>

      <div className="border-t border-white/5 p-3">
        <div className="flex items-center gap-3 px-2 py-2 mb-1">
          <div className="w-9 h-9 rounded-full bg-amber-400 text-[#0b1220] flex items-center justify-center font-bold">
            {user?.name?.[0]?.toUpperCase() || "U"}
          </div>
          <div className="min-w-0">
            <p className="text-white text-sm font-semibold truncate">{user?.name || user?.username || "User"}</p>
            <span className={`text-[10px] px-2 py-0.5 rounded-full ${isAdmin ? "bg-amber-400 text-[#0b1220]" : "bg-slate-600 text-white"}`} data-testid="user-role-badge">
              {ROLE_LABEL[role] || "Viewer"}
            </span>
          </div>
        </div>
        <button
          data-testid="logout-button"
          onClick={logout}
          className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium text-slate-300 hover:bg-white/5"
        >
          <LogOut className="w-[18px] h-[18px]" /> Logout
        </button>
      </div>
    </aside>
  );
}
